module.exports = "<div class=\"container\">\n    <h1>{{title}}</h1>\n    <div class=\"shelf-element-area\">\n        <app-shelf-elements></app-shelf-elements>\n    </div>\n    <div class=\"scene-area\">\n        <app-scene></app-scene>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main